(function () {
  function perView(carousel) {
    var d = parseInt(carousel.getAttribute('data-dyl-per-desktop') || '3', 10);
    var m = parseInt(carousel.getAttribute('data-dyl-per-mobile') || '1', 10);
    if (typeof window !== 'undefined' && window.matchMedia) {
      if (window.matchMedia('(min-width: 1200px)').matches) return Math.max(1, d);
      return Math.max(1, m);
    }
    return Math.max(1, d);
  }

  var MAX_DOTS = 10;

  function pageCount(slides, pv) {
    if (!slides.length) return 0;
    return Math.max(1, Math.ceil(slides.length / pv));
  }

  function pageStartIndex(page, slideCount, pv) {
    var lastStart = Math.max(0, slideCount - pv);
    return Math.min(page * pv, lastStart);
  }

  function activePageIndex(track, slides, pv, pages) {
    var scroll = track.scrollLeft;
    var best = 0;
    var bestDist = Infinity;
    for (var p = 0; p < pages; p++) {
      var slide = slides[pageStartIndex(p, slides.length, pv)];
      if (!slide) continue;
      var dist = Math.abs(slide.offsetLeft - scroll);
      if (dist < bestDist) {
        bestDist = dist;
        best = p;
      }
    }
    return best;
  }

  function renderDots(dotsWrap, count, activeIndex, labelPrefix) {
    if (!dotsWrap) return;
    if (count < 2 || count > MAX_DOTS) {
      dotsWrap.innerHTML = '';
      dotsWrap.hidden = true;
      return;
    }
    dotsWrap.hidden = false;
    var dots = dotsWrap.querySelectorAll('[data-dyl-dot]');
    if (dots.length !== count) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'dyl-dot';
        btn.setAttribute('data-dyl-dot', String(i));
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-label', (labelPrefix || 'Slide') + ' ' + (i + 1));
        dotsWrap.appendChild(btn);
      }
    }
    dotsWrap.querySelectorAll('[data-dyl-dot]').forEach(function (dot, i) {
      var on = i === activeIndex;
      dot.classList.toggle('is-active', on);
      dot.setAttribute('aria-current', on ? 'true' : 'false');
    });
  }

  function ensureVideoSrc(video) {
    if (video.dataset.src && !video.getAttribute('src')) {
      video.setAttribute('src', video.dataset.src);
      video.removeAttribute('data-src');
    }
  }

  function pauseVideoWrap(wrap) {
    var video = wrap.querySelector('video.dyl-video');
    if (video) {
      video.pause();
    }
    wrap.classList.remove('is-playing');
  }

  function playVideoWrap(wrap) {
    var video = wrap.querySelector('video.dyl-video');
    if (!video) return;
    ensureVideoSrc(video);
    video.muted = true;
    video.play().then(function () {
      wrap.classList.add('is-playing');
    }).catch(function () {});
  }

  function pauseAllVideosInCarousel(carousel) {
    carousel.querySelectorAll('[data-dyl-video-wrap]').forEach(pauseVideoWrap);
  }

  function initCarousel(carousel) {
    if (!carousel || carousel.dataset.dylInit === '1') return;
    var track = carousel.querySelector('[data-dyl-track]');
    var slides = track ? carousel.querySelectorAll('[data-dyl-slide]') : [];
    var dotsWrap = carousel.querySelector('[data-dyl-dots]');
    var prevBtn = carousel.querySelector('[data-dyl-prev]');
    var nextBtn = carousel.querySelector('[data-dyl-next]');
    if (!track || !slides.length) return;

    carousel.dataset.dylInit = '1';

    var index = 0;
    var pv = perView(carousel);
    var pages = pageCount(slides, pv);
    var maxIndex = Math.max(0, pages - 1);
    var dotLabel = dotsWrap ? dotsWrap.getAttribute('data-dyl-dot-label') || 'Slide' : 'Slide';
    var autoplayMs = parseInt(carousel.getAttribute('data-dyl-autoplay-ms') || '0', 10);
    var timer = null;

    function syncPages() {
      pv = perView(carousel);
      pages = pageCount(slides, pv);
      maxIndex = Math.max(0, pages - 1);
      if (index > maxIndex) index = maxIndex;
      renderDots(dotsWrap, pages, index, dotLabel);
      updateNav();
    }

    function updateNav() {
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= maxIndex;
    }

    function playActiveMobileVideo() {
      if (window.innerWidth >= 1024) return;
      var start = pageStartIndex(index, slides.length, pv);
      var end = start + pv;
      slides.forEach(function (slide, i) {
        var wrap = slide.querySelector('[data-dyl-video-wrap]');
        if (!wrap) return;
        if (i >= start && i < end) {
          playVideoWrap(wrap);
        } else {
          pauseVideoWrap(wrap);
        }
      });
    }

    function scrollToIndex(i, behavior) {
      index = Math.max(0, Math.min(i, maxIndex));
      var slide = slides[pageStartIndex(index, slides.length, pv)];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: behavior || 'smooth' });
      renderDots(dotsWrap, pages, index, dotLabel);
      updateNav();
      
      if (window.innerWidth < 1024) {
        var delay = behavior === 'smooth' ? 300 : 0;
        window.setTimeout(playActiveMobileVideo, delay);
      }
    }

    function onScrollEnd() {
      index = activePageIndex(track, slides, pv, pages);
      renderDots(dotsWrap, pages, index, dotLabel);
      updateNav();
      
      if (window.innerWidth < 1024) {
        playActiveMobileVideo();
      }
    }

    var scrollTimer;
    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(onScrollEnd, 80);
    });

    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (e) {
        var dot = e.target.closest('[data-dyl-dot]');
        if (!dot) return;
        var i = parseInt(dot.getAttribute('data-dyl-dot'), 10);
        if (isNaN(i)) return;
        scrollToIndex(i);
        resetAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollToIndex(index - 1);
        resetAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToIndex(index + 1);
        resetAutoplay();
      });
    }

    function resetAutoplay() {
      if (timer) window.clearInterval(timer);
      if (autoplayMs < 1000) return;
      timer = window.setInterval(function () {
        syncPages();
        var next = index >= maxIndex ? 0 : index + 1;
        scrollToIndex(next);
      }, autoplayMs);
    }

    function onResize() {
      syncPages();
      scrollToIndex(index, 'auto');
    }

    window.addEventListener('resize', onResize);
    syncPages();
    scrollToIndex(0, 'auto');
    resetAutoplay();

    // Intersection Observer to handle vertical scroll play/pause
    if (typeof IntersectionObserver !== 'undefined') {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            pauseAllVideosInCarousel(carousel);
          } else {
            if (window.innerWidth < 1024) {
              playActiveMobileVideo();
            }
          }
        });
      }, { threshold: 0.15 });
      observer.observe(carousel);
    }
  }

  function initVideoPlay(wrap) {
    if (!wrap || wrap.dataset.dylVideoInit === '1') return;
    var btn = wrap.querySelector('[data-dyl-play]');
    var video = wrap.querySelector('video.dyl-video');
    if (!video) return;

    wrap.dataset.dylVideoInit = '1';

    // Desktop hover play/pause
    wrap.addEventListener('mouseenter', function () {
      if (window.innerWidth >= 1024) {
        playVideoWrap(wrap);
      }
    });

    wrap.addEventListener('mouseleave', function () {
      if (window.innerWidth >= 1024) {
        pauseVideoWrap(wrap);
      }
    });

    // Toggle on click
    wrap.addEventListener('click', function (e) {
      e.preventDefault();
      if (video.paused) {
        playVideoWrap(wrap);
      } else {
        pauseVideoWrap(wrap);
      }
    });
  }

  function boot(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-dyl-carousel]').forEach(initCarousel);
    root.querySelectorAll('[data-dyl-video-wrap]').forEach(initVideoPlay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('[data-dyl-carousel]').forEach(function (el) {
      delete el.dataset.dylInit;
    });
    e.target.querySelectorAll('[data-dyl-video-wrap]').forEach(function (el) {
      delete el.dataset.dylVideoInit;
    });
    boot(e.target);
  });
})();
